import React, { useState, useEffect } from 'react';
import { signOut } from 'firebase/auth';
import { roomManagerAuth } from '../../firebase';
import AddRoom from './AddRoom';
import RoomSchedule from './RoomSchedule';
import { useNavigate } from 'react-router-dom';

const auth = roomManagerAuth;

const navItems = [
  { id: 'addRoom', label: 'Add Room' },
  { id: 'roomSchedule', label: 'Room Schedule' }
];

export default function RoomDashboard() {
  const navigate = useNavigate();
  const [page, setPage] = useState('addRoom');
  const [profileMenuOpen, setProfileMenuOpen] = useState(false);
  const profilePicUrl = 'https://ui-avatars.com/api/?name=Room+Manager';
  const profileName = 'Room Manager';

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (!user) {
        navigate('/room-management-login');
      }
    });
    return unsubscribe;
  }, [navigate]);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      localStorage.removeItem('roomPortalLogin');
      localStorage.removeItem('roomPortalRole');
      localStorage.removeItem('servicesPortalRole');
      localStorage.removeItem('servicesPortalLogin');
      navigate('/room-management-login');
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="room-management-layout" style={{ minHeight: '100vh', background: '#f5f5f5', display: 'flex', flexDirection: 'row' }}>
      {/* Sidebar */}
      <div className="room-management-sidebar" style={{ width: 220, background: '#155c2b', color: '#fff', display: 'flex', flexDirection: 'column', alignItems: 'stretch', padding: '32px 0', minHeight: '100vh', boxShadow: '2px 0 8px #eee' }}>
        <div style={{ fontWeight: 700, fontSize: 22, textAlign: 'center', marginBottom: 40, letterSpacing: 2 }}>ENROLLEASE</div>
        
        {navItems.map(item => (
          <button
            key={item.id}
            onClick={() => setPage(item.id)}
            style={{
              background: page === item.id ? '#e67e22' : 'transparent',
              color: '#fff',
              border: 'none',
              borderRadius: 6,
              padding: '14px 0',
              fontWeight: 600,
              fontSize: 16,
              cursor: 'pointer',
              textAlign: 'left',
              paddingLeft: 32,
              marginBottom: 8,
              marginRight: 12,
              transition: 'background 0.2s, color 0.2s',
              boxShadow: page === item.id ? '0 2px 8px #e67e22aa' : 'none'
            }}
            onMouseEnter={(e) => page !== item.id && (e.target.style.background = 'rgba(230, 126, 34, 0.15)')}
            onMouseLeave={(e) => page !== item.id && (e.target.style.background = 'transparent')}
          >
            {item.label}
          </button>
        ))}
        
        <div style={{ flex: 1 }} />
      </div>

      {/* Main */}
      <div className="room-management-main" style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        {/* Header */}
        <div className="room-management-header" style={{ height: 80, background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'space-between', boxShadow: '0 2px 8px rgba(0,0,0,0.04)', padding: '0 40px', position: 'relative', zIndex: 10 }}>
          <h1 style={{ margin: 0, fontSize: 24, color: '#155c2b', fontWeight: 600 }}>Room Management</h1>
          
          <div style={{ display: 'flex', alignItems: 'center', position: 'relative', gap: 16 }}>
            <span style={{ fontWeight: 600, fontSize: 16, color: '#155c2b' }}>{profileName}</span>
            <button
              onClick={() => setProfileMenuOpen(!profileMenuOpen)}
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: 0,
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <img
                src={profilePicUrl}
                alt="Profile"
                style={{ width: 44, height: 44, borderRadius: '50%', objectFit: 'cover', border: '2px solid #e67e22' }}
              />
            </button>

            {profileMenuOpen && (
              <div style={{
                position: 'absolute',
                top: '100%',
                right: 0,
                marginTop: 8,
                background: '#fff',
                border: '1px solid #e0e0e0',
                borderRadius: 8,
                boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
                zIndex: 20,
                minWidth: 200,
                overflow: 'hidden'
              }}>
                <div style={{ padding: '12px 16px', fontWeight: 600, color: '#155c2b', borderBottom: '1px solid #f0f0f0' }}>
                  {profileName}
                </div>
                <button
                  onClick={() => {
                    setProfileMenuOpen(false);
                  }}
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    background: 'transparent',
                    border: 'none',
                    color: '#222',
                    fontSize: 14,
                    fontWeight: 500,
                    cursor: 'pointer',
                    textAlign: 'left',
                    transition: 'background 0.2s'
                  }}
                  onMouseEnter={(e) => e.target.style.background = '#f5f5f5'}
                  onMouseLeave={(e) => e.target.style.background = 'transparent'}
                >
                  Profile
                </button>
                <button
                  onClick={() => {
                    setProfileMenuOpen(false);
                  }}
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    background: 'transparent',
                    border: 'none',
                    color: '#222',
                    fontSize: 14,
                    fontWeight: 500,
                    cursor: 'pointer',
                    textAlign: 'left',
                    transition: 'background 0.2s'
                  }}
                  onMouseEnter={(e) => e.target.style.background = '#f5f5f5'}
                  onMouseLeave={(e) => e.target.style.background = 'transparent'}
                >
                  Settings
                </button>
                <div style={{ height: 1, background: '#eee', margin: '6px 0' }} />
                <button
                  onClick={() => {
                    setProfileMenuOpen(false);
                    handleLogout();
                  }}
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    background: 'transparent',
                    border: 'none',
                    color: '#e67e22',
                    fontSize: 14,
                    fontWeight: 600,
                    cursor: 'pointer',
                    textAlign: 'left',
                    transition: 'background 0.2s'
                  }}
                  onMouseEnter={(e) => e.target.style.background = '#fef5f0'}
                  onMouseLeave={(e) => e.target.style.background = 'transparent'}
                >
                  Log out
                </button>
              </div>
            )}
          </div>
        </div>

        {/* Content */}
        <div className="room-management-content" style={{ flex: 1, padding: 40, overflowY: 'auto' }}>
          <div style={{ maxWidth: 1200, margin: '0 auto' }}>
            {page === 'addRoom' && <AddRoom />}
            {page === 'roomSchedule' && <RoomSchedule />}
          </div>
        </div>
      </div>
    </div>
  );
}
